export default __webpack_public_path__ + "static/media/Blog12.9.c1c838a6.png";